import React from "react";

const Help = () => (
  <div className="page-container">
    <div className="page-content">
      <h1 className="page-title">Help & Support</h1>
      
      {/* FAQ section removed as requested */}

      <section className="about-section" id="contact">
        <h2>Need Help?</h2>
        <p>
          If you have a question or if you're experiencing an issue with 
          the app, please don't hesitate to reach out.
        </p>
      </section>


      <section className="about-section">
        <h2>Feature Requests & Feedback</h2>
        <p>
          As an indie developer, I value your input! If you have ideas for new features or 
          suggestions for improving Simple Step Counter, I'd love to hear them.
        </p>
        <p>
          Please send your feedback to the email address above, or leave a review on the Google 
          Play Store. Your support and suggestions help shape the future of Simple Step Counter.
        </p>
      </section>

      <section className="about-section" id="contact-info">
        <h2>Contact Information</h2>
          <p>
            <strong>Email:</strong>{" "}
            <a href={"mailto:" + ["kjm.application","gmail.com"].join("@")} className="inline-link">
              {["kjm.application","gmail.com"].join("@")}
            </a>
          </p>
          <p>
            I try to reply as fast as possible, but it might take a while. Be assured, I eventually read every email.<br />
            Please give as many details as possible if you're reporting a technical issue.
          </p>
      </section>

    </div>
  </div>
);

export default Help;
